module.exports = __webpack_public_path__ + "static/media/history-icon.56098465.svg";